export default function() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-geo-projection/src/noop.js
// module id = 299
// module chunks = 0